import React, { useMemo } from 'react';
import ReactSelect from '../ReactSelect';
import { Props } from 'react-select';
import useMakesAndModels from '../../hooks/useMakesAndModels';
import { GroupBase } from 'react-select/dist/declarations/src/types';

export type MakeOption = { label: string; value: string };
type MakePickerProps<
  IsMulti extends boolean = false,
  Group extends GroupBase<MakeOption> = GroupBase<MakeOption>,
> = Partial<Props<MakeOption, IsMulti, Group>> & { makeId?: string };

const MakePicker: React.FC<MakePickerProps> = (props): JSX.Element => {
  const { makes, makeNames, loading } = useMakesAndModels();
  const options = useMemo(() => {
    if (!makes) {
      return [];
    }
    return makes.map((make) => {
      return {
        label: make.name,
        value: make.id,
      };
    });
  }, [makes]);

  const value = useMemo<MakeOption | null>(() => {
    return makeNames && props.makeId
      ? { label: makeNames[props.makeId], value: props.makeId }
      : null;
  }, [props.makeId, makeNames]);

  return (
    <ReactSelect
      menuPlacement="auto"
      placeholder=""
      {...props}
      styles={{
        ...props.styles,
        menu: (base) => ({
          ...base,
          minWidth: '175px',
        }),
      }}
      value={value}
      options={options}
      isLoading={loading}
    />
  );
};

export default MakePicker;
